import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import SearchPokemonForm from './Components/forms/searchPokemon';
import Navbar from './Views/template/navbar/navbar';
import Content from './Views/content';
import OffcanvasBase from './Components/offcanvas/offcanvasBase';
import { PokedexProvider } from './Data/Context/pokemonData';
import { AppConfig } from './Config/App';
import { BuildProvider } from './Data/Context/buildData';
import { DatabaseProvider } from './Controllers/Database';
import { Bounce, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LanguageProvider } from './Data/Context/languageContext';
import LoadingAnimation from './Components/loadingAnimation';

function App() {
    const [isLoaded, setIsLoaded] = useState(false);
    useEffect(() => {
        setIsLoaded(true);
    }, []);

    if (!isLoaded) {
        return <LoadingAnimation />;
    } else
        return (
            <LanguageProvider>
                <AppConfig production={true}>
                    <PokedexProvider>
                        <Router>
                            <BuildProvider>
                                <DatabaseProvider>
                                    <Navbar />
                                    <Content></Content>
                                    <OffcanvasBase id='offcanvas-search-1'>
                                        <SearchPokemonForm
                                            classes='mt-4'
                                            dismiss={'offcanvas'}
                                        />
                                    </OffcanvasBase>
                                </DatabaseProvider>
                            </BuildProvider>
                        </Router>
                    </PokedexProvider>
                    <ToastContainer
                        position='bottom-right'
                        closeOnClick
                        draggable
                        theme='dark'
                        pauseOnFocusLoss={true}
                        newestOnTop
                        pauseOnHover={true}
                        autoClose={2000}
                        transition={Bounce}
                    />
                </AppConfig>
            </LanguageProvider>
        );
}

export default App;
